import React from "react";
import { useRoutePath } from "../../../../../util/Routing";
import { EntityListPage } from "../shared/EntityListPage";

export function DistributorsListPage(): JSX.Element {
  const { adminPath } = useRoutePath();
  return (
    <EntityListPage
      entityType="distributor"
      detailBasePath={`${adminPath}/mdm/distributors`}
    />
  );
}
